var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarCrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Component_57_2",
    width: 400.066,
    height: 230,
    viewBox: "0 0 400.066 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-19{fill:none}.cls-2{fill:#e8ecf0}.cls-17,.cls-4{fill:#bac0cd}.cls-16,.cls-6{fill:#fff}.cls-6{stroke:#8991a0;stroke-width:.81px;stroke-dasharray:14.53 1.61 .81 4.04}.cls-17,.cls-19,.cls-6{stroke-linecap:round}.cls-6{stroke-miterlimit:10}.cls-7{fill:#8991a0}.cls-8{fill:#1d243f}.cls-12,.cls-20,.cls-9{fill:#343a5c}.cls-10{fill:#b9a5d6}.cls-11{fill:#753bbb}.cls-12{opacity:.5}.cls-15{fill:#474e5e}.cls-17,.cls-19{stroke:#fff;stroke-width:1.26px;stroke-linejoin:round;stroke-dasharray:30.32 1.68 1.68 3.37}.cls-19{stroke:#e8ecf0;stroke-width:.84px}.cls-20{opacity:.64}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4477",
    fill: "none",
    d: "M0 0H400V230H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(0 11.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20696",
    d: "M373.74 186.14c2.52-3.34 37.5-51 22.68-93.87-19.26-55.73-74.52-67.2-109.48-40.77-8.33 6.29-24.56 28.94-40.38 29.2C218.67 81.17 161.42-.37 98.19 0c-42 .25-79.4 35.44-80.13 83.83-.54 36 34.81 30.34 25.63 59-6.45 20.08-25.69 36.27-41.37 41.9z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20697",
    fill: "#bac0cd",
    d: "M40.63 184.88L171.82 66.17l108.23 118.71z",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20698",
    d: "M177.65 184.88l109.03-58.5 73.41 58.5z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2491",
    cx: 12.97,
    cy: 12.97,
    r: 12.97,
    className: "cls-4",
    transform: "translate(119.49 43.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20699",
    d: "M9.33 186.19h-.39c-.34.02-.18.01.39 0z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4478",
    fill: "#d4d8e0",
    d: "M0 0H377.92V2.03H0z",
    transform: "translate(0 184.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20700",
    d: "M312 109.24c6.75 5.43 8.33 11 4.84 17.2-2.72 4.82-8 8.69-16.62 5.3-1 2.67-2.61 4.77-5.53 5.45-3.19.75-5-1-6.19-3.67-1.21.32-2.24.68-3.31.86a3.82 3.82 0 0 1-2.32 0c-3-1.76-6.42-1.83-9.63-2.71a6.93 6.93 0 0 0-4.4-.12c-1.55.57-3 1.36-4.75 2.16a7.37 7.37 0 0 0 6 2.15c2.32-.2 3.55.5 4.05 2.21a3.87 3.87 0 0 1-2.17 4.71 23.6 23.6 0 0 0-11 10 6.8 6.8 0 0 1 .17-2.14 74.3 74.3 0 0 1 3.47-7.12c1-1.81.85-2.66-1.23-3-1.32-.23-2.67-.21-4-.43a53.3 53.3 0 0 1-7.46-1.52 12 12 0 0 1-4.24-2.72c-1.77-1.68-3-3.82-4.95-5.44-2.2-1.82-1.79-5.16.48-7a20.161 20.161 0 0 1 3.05-1.76c.23-3.8 2-6.54 8.87-6.82 2.05-.08 3.95.09 5.79-1.34 1.53-1.2 3.54-.93 5.45-.43a3.73 3.73 0 0 0 2.31-.18 10.6 10.6 0 0 1 6.55-1 5.07 5.07 0 0 0 2.1-.5c2-.62 4-1.64 6-1.77 2.48-.17 2.38-2.29 3.27-3.57.29-.4-.55-1.83-1.15-2.57-2.19-2.66-5.32-2.91-8.72-1-1.72 1-3.58 1.73-5.34 2.65a4.49 4.49 0 0 0-1.28 1.18 5.82 5.82 0 0 1-10.51-3.92 10.8 10.8 0 0 0 0-1.8 7.67 7.67 0 0 1 5-8.54 3 3 0 0 0 1.89-1.93c2.47-6.17 9.17-8 14.56-4.09a3.34 3.34 0 0 0 2.24.48 7.68 7.68 0 0 1 6.37 1.79l1.19-.74a6.39 6.39 0 0 1 9.46 2.89 2.43 2.43 0 0 0 1.9 1.55c1.48.41 3.39.91 4.13 2 2 3.05 6.09 4.14 7.21 7.93.89 2.76.03 5.08-1.55 7.32z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20701",
    d: "M261 107.16c.14-.56 3.11.72 6.16-.73 2.19-1 2-2.36 4.35-4.34a13.21 13.21 0 0 1 9-3.26c.29 0 4.73.37 7.25 3.62.25.33 1.7 2.25 1.08 3.26-.31.51-.92.44-1.81 1.09a9 9 0 0 0-1.53 1.69c-.12-.06 1.2-2 1-3.32s-2.66-3-4.35-3.26a7.66 7.66 0 0 0-5.07 1.08c-1.41.81-1.23 1.25-2.53 1.81-2 .85-3.06.14-4 1.09s-.25 1.68-1.09 2.54-2.5.82-3.62.72c-2.56-.22-5-1.48-4.84-1.99z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20702",
    d: "M263.69 134.22c-.17-.23 3.29-3.31 5.56-3.34h.44a17.152 17.152 0 0 1 2.9.37c2.93.51 4.08.23 4.7 0h.12c1.87-.68 2.2-2.79 3-2.59.6.15.34 1.37 1.3 2.41a3.76 3.76 0 0 0 3 1.11c2.59-.28 3.6-4 4.82-3.71.74.2.38 1.58 1.48 2.6s3.55 1.16 5.19.37c2.41-1.17 2.6-3.75 4.08-3.71.87 0 1.12.92 2.22 1.85 2.61 2.2 6.48 1.58 7.05 1.49 4.79-.77 7.39-5.52 7.78-5.19s-.95 2.57-3 4.44a12.2 12.2 0 0 1-14.45 1.86 5.79 5.79 0 0 1-.74 3 5.93 5.93 0 0 1-5.56 3 6.1 6.1 0 0 1-4.08-2.23l-1.16-1.95a14.57 14.57 0 0 1-2.6.74 7.62 7.62 0 0 1-4.44 0 5.55 5.55 0 0 1-2.6-2.22 9.281 9.281 0 0 1-2.22.37c-1.77.06-2.52-.46-4.45-.74a11.52 11.52 0 0 0-4.08 0c-2.75.57-4.14 2.22-4.26 2.07z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20703",
    d: "M266 122.16a12.161 12.161 0 0 0 3.19 1.7 3.17 3.17 0 0 0 1.64.07 5.07 5.07 0 0 0 1.52-.77 6.64 6.64 0 0 1 .84-.49 1.21 1.21 0 0 1 1.26 0 1.1 1.1 0 0 1 .37.57c.05.17.08.29.12.4a1.31 1.31 0 0 0 .47.56 1.87 1.87 0 0 0 1.53.33 1.47 1.47 0 0 0 .92-1.33 1.57 1.57 0 0 1-.78 1.69 2.21 2.21 0 0 1-2-.17 1.84 1.84 0 0 1-.77-.79c-.16-.35-.22-.66-.3-.66-.14-.16-.75.19-1.23.53a5.58 5.58 0 0 1-1.79.84 3.65 3.65 0 0 1-2-.22 8.17 8.17 0 0 1-2.99-2.26z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20704",
    d: "M291.68 118.08a20.225 20.225 0 0 0 1.58 1.5 4.83 4.83 0 0 0 1.77 1 1.62 1.62 0 0 0 1.65-.54 5.67 5.67 0 0 1 1.76-1.54 1.51 1.51 0 0 1 1.4.22 4.86 4.86 0 0 0 .8.65 2.88 2.88 0 0 0 1.89.19 4.43 4.43 0 0 0 3.12-2.59 4.26 4.26 0 0 1-1 2 4.67 4.67 0 0 1-2 1.2 3.3 3.3 0 0 1-2.39-.12 5.09 5.09 0 0 1-.92-.69.71.71 0 0 0-.68-.09c-.5.16-.93.81-1.5 1.33a2.73 2.73 0 0 1-1.07.64 2.1 2.1 0 0 1-1.27-.06 7.43 7.43 0 0 1-3.14-3.1z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20705",
    d: "M297.48 102a4.3 4.3 0 0 0 3.52 1.47 5.15 5.15 0 0 0 3.33-2 3.64 3.64 0 0 1-1.16 1.86 3.88 3.88 0 0 1-2.09.93 3.44 3.44 0 0 1-3.6-2.26z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20706",
    d: "M345.39 202.94a1 1 0 0 0-.36.73c0 .16.12.42.73.73a4.13 4.13 0 0 0 3.27.36c1.38-.51 1.2-1.46 2.54-1.82 1-.26 1.53.14 2.18-.36a2.12 2.12 0 0 0 .72-1.45c.1-.75-.09-1.92-.72-2.18-1.33-.55-2.88 3.66-5.81 3.63-.74-.01-1.85-.28-2.55.36z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20707",
    d: "M357.74 196a1.57 1.57 0 0 0-.72 1.09 2.17 2.17 0 0 0 .36 1.45c.5.95.92.87 1.09 1.46.25.86-.55 1.31-.36 2.18s.91 1.15 1.45 1.45c1.35.74 3.56 1.06 4.36 0a2.45 2.45 0 0 0 .36-1.45 3.49 3.49 0 0 0-.36-1.46 10.84 10.84 0 0 0-4.36-4.35c-.87-.37-1.39-.54-1.82-.37z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20708",
    d: "M348.66 194.23c-.08 1.84.86 2.45.73 5.08-.06 1.26-.32 2 0 2.18.52.32 2-1.15 3.27-2.54-.09-1.32-.21-3-.37-5.09-.27-3.57-.35-4.25-.72-4.36-.79-.21-2.79 2.15-2.91 4.73z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20709",
    d: "M358.47 191.68c-.69 1 .54 1.8.73 5.09a1.41 1.41 0 0 0 .36 1.09 2 2 0 0 0 2.54-.73c.29-.5.08-.9 0-1.81-.2-2.38.9-3.26.36-4-.65-.9-3.18-.8-3.99.36z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20710",
    d: "M342 108.43a4.86 4.86 0 0 1-1.62-1.25 5 5 0 0 1-.81-4.06c.09-.4.53-2.2 1.62-2.44.78-.17 1.2.61 2.44.81.48.08.57 0 2.44-.4a18.85 18.85 0 0 1 2.43-.41 5.42 5.42 0 0 1 3.25 1.22c1 .86.72 1.41 2 7.31a18.649 18.649 0 0 1-.75 4.52c-.59.85-1.75-3.53-6.15-4.11a12.86 12.86 0 0 1-4.85-1.19z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20711",
    d: "M342.12 146.06a151.707 151.707 0 0 0 1.09 16.34c.27 2 1 7.52 2.18 10.17a5.168 5.168 0 0 1 .37 1.09 6.47 6.47 0 0 1-.15 3.24 9 9 0 0 0-.24 3.83l2 14.26h5.39a87.431 87.431 0 0 0 .42-18.13c0-.65-.24-3.26-.54-7.56-.47-6.61-.56-8.32-.37-8.35.36 0 .07 6 3.27 12a13.51 13.51 0 0 1 1.82 5.09 12.2 12.2 0 0 1-.15 3.81 13.54 13.54 0 0 0-.26 2.1l-.32 9.61 6.18-.36a33 33 0 0 0 1.45-13.35c-.33-2.78-1-3.77-1.45-7.26a40.46 40.46 0 0 1 0-10.17c.38-4.17.33-10.57-1.82-20z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20712",
    d: "M316.34 135.16c-.56-.13-.49-1-1.09-1.82s-1-.5-2.18-1.45-1.5-1.94-1.82-1.81-.24.57-.18.9c.11.65.63 1.1 1.45 1.82.49.42.78.61.73.73s-.42 0-1.09 0-1.94-.11-2.18.36c-.05.1 0 .1 0 .73s-.05.59 0 .72c.17.38.62.34.73.73v.36c0 .51-.07.58 0 .73s.27.15.36.36-.1.45 0 .73a.78.78 0 0 0 .36.36 3.49 3.49 0 0 0 2.91.36c.9-.37 1-1 1.82-1.09.58-.07.77.18 1.09 0 .79-.43.66-2.66 0-2.9-.31-.12-.52.28-.91.18z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20713",
    d: "M342.31 117.73a15.9 15.9 0 0 0-3.27 2.18c-1.64 1.4-1.42 2.49-2.91 3.26-.61.32-1.4.56-1.63 1.28-.15.43.06.62 0 1.09s-.24.8-2.18 2.17a27.73 27.73 0 0 1-2.91 1.82c-.6.32-1.09.56-1.45.73a64 64 0 0 1-8.72 3.27c-.71.2-1.7.46-2.9.72v4.35h2.62c3.5-.06 6.15-.32 6.46-.35 3.38-.37 9.91-4.45 17.07-10.9z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20714",
    d: "M342.49 127.35l-.18-9.62q-.53.26-1.14.63a14.47 14.47 0 0 1-1 5.72 16 16 0 0 1-4 5.45 26.49 26.49 0 0 1-11.62 6.54 28.25 28.25 0 0 1-8.17.89v1.64H319c3.5-.06 6.15-.32 6.46-.35 3.34-.37 9.87-4.45 17.03-10.9z",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20715",
    d: "M354.11 115.18c-.66-1.44-1.9-2.61-1.82-4.72 0-.83.25-1.24 0-1.45-.72-.64-4.48 1.25-6.17 4.36-2 3.64-1.33 9.41 1.82 10.89a4.63 4.63 0 0 0 4.35-.36c2.44-1.62 3.08-5.9 1.82-8.72z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20716",
    d: "M341 118.45a102.879 102.879 0 0 1 1.81 12 9.59 9.59 0 0 0 .36 3.63 2.79 2.79 0 0 1 .37 1.82c-.19.67-.67.74-1.09 1.45s-.29 1.34-.37 2.54a19 19 0 0 1-.72 3.27c-.57 2.51-.85 3.76-.73 4.36.46 2.15 3.22 3.25 5.09 4a16 16 0 0 0 10.89.37c1.31-.44 2.36-1.87 4.72-2.55a2.56 2.56 0 0 0 1.28-.54c1.2-1.18.17-3.9-.37-5.81 0-.08.08.27-.72-9.81-.53-6.54-1-12.67-1.46-17.43a6.18 6.18 0 0 1-2.54 0 7.4 7.4 0 0 1-3.27-1.82 9.994 9.994 0 0 1-1.09-1.09 5 5 0 0 1 0 1.46 5.78 5.78 0 0 1-1.45 2.9 7.07 7.07 0 0 1-.73.73l.37 1.09-.37.72.73.73a15.912 15.912 0 0 0-2.18 2.54c0 .37-2.91-4.36-2.91-4.36a6.55 6.55 0 0 1-1.45-1.45 3.05 3.05 0 0 1-.36-1.09z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20717",
    d: "M350.62 152.77c.21-2.49.46-5 .57-7.45a51.18 51.18 0 0 0-.13-7.43c-.28-2.48-.82-4.93-1.19-7.4-.18-1.24-.34-2.48-.46-3.73l-.17-1.88c-.05-.64 0-1.27-.05-1.88v-.15l.1-.11 2.19-2.53v.5l-.71-.74-.18-.19.11-.21.39-.72v.25l-.34-1.1-.06-.21.17-.12a4.89 4.89 0 0 0 1.74-2.06 11.249 11.249 0 0 0 .58-2.79h.07a9.572 9.572 0 0 1-.28 2.91 4.09 4.09 0 0 1-.7 1.34 5.7 5.7 0 0 1-1.06 1.08l.11-.34.39 1.08v.12l-.06.13-.35.74-.06-.4.74.71.24.24-.22.26-2.17 2.55.17-.24c0 2.49.24 5 .42 7.45a71.724 71.724 0 0 0 1 7.42 29.938 29.938 0 0 1 .47 7.5 45.156 45.156 0 0 1-1.11 7.43z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20718",
    d: "M361.56 133.16c-.53-6.54-1-12.67-1.46-17.43a6.26 6.26 0 0 1-2 .09 6 6 0 0 1-.7 3c-1.48 2.67-4.52 2.58-5.09 5.08-.46 2.08 1.48 2.84 2.55 6.54.23.82 1.76 6.11-.73 9.44-2.22 3-6 2.15-6.9 4.72-.7 1.94.79 4.13 1.45 5.09a16.931 16.931 0 0 0 2.69 3 15.59 15.59 0 0 0 5.3-.78c1.31-.44 2.36-1.87 4.72-2.55a2.56 2.56 0 0 0 1.28-.54c1.2-1.18.17-3.9-.37-5.81-.04-.12.06.23-.74-9.85z",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20719",
    d: "M360.19 115.64c.51-.16 1.07.22 1.82.72a8.449 8.449 0 0 1 2.18 2.18c2.44 3.65 3.26 5.83 5.81 11.63.37.84.71 1.61.36 2.18-.67 1.07-4 2.16-5.81.72s-.79-2.87-2.54-6.17c-1.5-2.84-2.74-2.8-3.27-5.09s.37-5.81 1.45-6.17z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20720",
    d: "M360.19 115.64c.51-.16 1.07.22 1.82.72a8.449 8.449 0 0 1 2.18 2.18c2.44 3.65 3.26 5.83 5.81 11.63.37.84.71 1.61.36 2.18-.67 1.07-4 2.16-5.81.72s-.79-2.87-2.54-6.17c-1.5-2.84-2.74-2.8-3.27-5.09s.37-5.81 1.45-6.17z",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20721",
    d: "M362.83 128.26a5.121 5.121 0 0 1-1.09-1.45 14.861 14.861 0 0 1-.73-2.55c-.58-1.82-.81-2.12-1.09-2.18a.53.53 0 0 0-.54.19c-.06.09-.08.25.36 1.09.28.54.4.68.36.72s-.38-.09-1.55-1a1.77 1.77 0 0 0-1.41-.32 2.56 2.56 0 0 0-1.62 1.08l-.14.21 1.6 1.09-1.59-.59a.5.5 0 0 0-.59.2.51.51 0 0 0 .11.67l.11.09 1.81.72L355 126a.32.32 0 0 0-.37.26.31.31 0 0 0 .26.36 4.29 4.29 0 0 1 2 .78 9.813 9.813 0 0 1 1.46 1.45 4.4 4.4 0 0 0 1.09 1.09 2.83 2.83 0 0 0 1.45.37l1.09.72z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20722",
    d: "M362.46 126.81c-.25.18.08.68 0 1.81s-.47 2.46-1.09 2.54-1-.8-1.09-.72.3.79.73 1.45a17.151 17.151 0 0 0 1.09 1.45c.73.95.82 1.13 1.09 1.46.1.11 2.3 2.75 4.36 2.18a3.08 3.08 0 0 0 1.45-1.09c.22-.25 1.95-2.17 1.27-4.18a3.79 3.79 0 0 0-1.45-1.82c-1-.74-1.54-.52-2.91-1.09-2.12-.87-3.02-2.3-3.45-1.99z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20723",
    d: "M342.85 109.37c.73 2.55-.25 3.66.73 6.18.4 1 .71 1.83 1.09 1.81.81 0 1.69-3.94 0-6.53-.36-.55-1.98-2.03-1.82-1.46z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20724",
    fill: "#d3c1e9",
    d: "M342.12 108.28c-.21.54.57.89 1.09 2.55a14.751 14.751 0 0 1 .37 2.17c.34 2 .51 3 1.09 3.64a4.18 4.18 0 0 0 3.27 1.09 4.79 4.79 0 0 0 4-3.64 4.58 4.58 0 0 0 0-2.17 2 2 0 0 0 .55-.19 2.43 2.43 0 0 0 1.09-1.81c0-.23.24-1.56-.37-1.82-.38-.16-1 .14-1.45.73a5.77 5.77 0 0 1-1.82-1.09c-1-.9-1.13-1.71-1.81-1.82s-.87.5-1.82 1.09c-2.02 1.26-3.86.44-4.19 1.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20725",
    d: "M345.34 107.47c-1.61.57-2.94.12-3.22.81-.21.54.57.89 1.09 2.55a14.751 14.751 0 0 1 .37 2.17c.34 2 .51 3 1.09 3.64a3.39 3.39 0 0 0 1.87 1c.39-.65-3.56-1.27-2.24-3.91 1.82-3.63 1.15-5.08 1.04-6.26z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20726",
    d: "M343.58 114.09a5.54 5.54 0 0 1 1.09-1.81c.48-.63.73-.94 1.09-1.09.82-.35 1.73.12 2.9.73a11 11 0 0 1 1.68 1 .52.52 0 0 0 .79-.18 4.13 4.13 0 0 0 .44-1.85V109l.72 2.87v.13a7.2 7.2 0 0 1 0 1.8 6.32 6.32 0 0 1-1.81 4 4.51 4.51 0 0 1-3.27 1.45 4.19 4.19 0 0 1-2.91-1.45 4 4 0 0 1-.72-3.71z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20727",
    d: "M352.35 118.25a.93.93 0 0 1 .75.25 1.23 1.23 0 0 1 .31.79c0 .51.08 1 .11 1.52l-.58-.17c.29-.48.57-1 .84-1.45a10.735 10.735 0 0 0 .71-1.45 6.779 6.779 0 0 0 .28-1.59c0-.55.07-1.12.07-1.69a7 7 0 0 1 .39 1.68 5.36 5.36 0 0 1-.09 1.78 7.059 7.059 0 0 1-.73 1.62 13.9 13.9 0 0 1-1 1.45l-.62.83.05-1c0-.5.06-1 .11-1.52a1 1 0 0 0-.08-.64.9.9 0 0 0-.52-.41z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_57",
    fill: "none",
    stroke: "#343a5c",
    strokeMiterlimit: 10,
    strokeWidth: "0.36px",
    d: "M0 0L3.4 5.25",
    transform: "translate(346.17 117.74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20728",
    d: "M347.75 121.54c-.32-.26-.77-.39-.94-.06a6.345 6.345 0 0 1-.71 1c-.12.16-.25.33-.4.5a1.46 1.46 0 0 1-.64.42 2.27 2.27 0 0 1-1.42-.08l-.37-.13.17-.37c.18-.38.38-.76.57-1.14v-.05a1.9 1.9 0 0 0 .24-.84 4.419 4.419 0 0 0-.05-1 17.679 17.679 0 0 0-.48-2.13 7.331 7.331 0 0 1 1 2 4 4 0 0 1 .2 1.16 2.22 2.22 0 0 1-.32 1.25c-.18.38-.36.77-.56 1.14l-.2-.49a1.77 1.77 0 0 0 1 .11.68.68 0 0 0 .39-.22q.21-.19.42-.42c.29-.29.55-.58.88-.88a.66.66 0 0 1 .7-.14 1.06 1.06 0 0 1 .52.37z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20729",
    d: "M345.39 114.46c-.05-.18.69-.66 1.46-.73s1.46.18 1.45.36c-.01.35-2.81.7-2.91.37z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20730",
    d: "M349 196.41c.64-.24 1.55.51 1.81.72.84.69 1 1.47 1.45 1.45a.92.92 0 0 0 .73-.72c.14-.52-.46-1-.36-1.09s.07 0 .18 0a1.45 1.45 0 0 1 .74.8c.67 1.71.49 2.45.17 2.8s-.68.22-1.46.73-.67.77-1.45 1.45c-.47.4-1.59 1.37-2.54 1.09-.55-.16-.51-.59-1.09-.73-.86-.21-1.56.59-1.82.37s0-.92.37-1.46c.52-.77 1.07-.8 1.63-1.27 1.56-1.25.64-3.76 1.64-4.14z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20731",
    d: "M357.74 196c.18-.39.7-.15 1.46-.72s.58-.93 1.08-1.09a1.91 1.91 0 0 1 1.46.36 3.14 3.14 0 0 1 1.63 1.63c.2.57-.06.62 0 1.82a7.24 7.24 0 0 0 .37 2.18c.25.73.5 1 .36 1.45a1.13 1.13 0 0 1-.73.73c-.56.15-.8-.4-1.45-.37s-.77.67-1.45.73A1.8 1.8 0 0 1 359 202c-.3-.4-.33-1-.36-2.17s.07-1 0-1.46c-.21-1.37-1.14-1.8-.9-2.37z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20732",
    d: "M352.84 108.46c-1.09.11-2.17.22-3.26.29l.11-.12v2.14h-.13l-2.18.38h-.09l-.06-.07c-.5-.47-1-1-1.45-1.46l.28-.07-.56 2v.1h-.09l-1.12.19-.57.08h-.29c-.11 0-.15.06-.34 0a2.36 2.36 0 0 1-.43-1.11c-.07-.37-.13-.75-.18-1.12.08.37.17.74.28 1.1a2.71 2.71 0 0 0 .43 1 2.19 2.19 0 0 0 .5-.06l.55-.11 1.11-.24-.11.11.52-2 .08-.28.21.2c.49.49 1 1 1.46 1.45h-.16l2.18-.34-.13.15v-2.11h.11c1.14-.09 2.24-.09 3.33-.1z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20733",
    d: "M67.11 152.13V67.56l2.86 86.95z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20734",
    d: "M64.49 67.79A47.52 47.52 0 0 1 77 66.17c7.33 0 9.13 1.79 9.69 2.42 1.68 1.89.8 3.41 2 4.85 4 4.76 20.29-3.82 21-2.42.47.91-6.26 5.38-13.72 9.28-8.6 4.49-14.15 7.33-16.55 5.25s2.42-8.65.4-10.5c-1.73-1.58-7.14 1.33-12.92 5.25z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20735",
    d: "M82.51 200.06a35.821 35.821 0 0 0-4.7-.63 7 7 0 0 1-6-2.82l-.21.18.82 1.7c-.34 0-.61.08-.88.08h-5.21c-1.5 0-2.3-.34-5-2l1.51 2.3a7.13 7.13 0 0 1-2.05-.4 9.75 9.75 0 0 0-5.39-1.06c-5.21.17-11-5-11.45-10.27a11.08 11.08 0 0 1 .71-4.43 20.39 20.39 0 0 1 9.73-11.51 1.18 1.18 0 0 0 .61-.65 8 8 0 0 0-1.84.21 1.76 1.76 0 0 1-1.93-.24 1.66 1.66 0 0 0-2.71.95 1.943 1.943 0 0 1-.07.33c-.33 1.62-1 2.84-3 2.54.63-3.4 2.77-5.21 6.14-5.79a6.83 6.83 0 0 0-5.33-3.61 2.55 2.55 0 0 0-.55 0 11.78 11.78 0 0 1-4.92-.71c-3.46-1.2-7.09 1.41-7.57 5.14l-.13 1.1a5.86 5.86 0 0 0-5.36 4.35l-2.72-.5c-.44-.89-.74-1-1.82-.18-3.85 2.92-5.71 6.77-5 11.73a34 34 0 0 0 .52 3.48c1.16 4.81 4.42 7.64 8.71 9.44a21.51 21.51 0 0 0 8.36 1.7h46.08a2.765 2.765 0 0 0 .64-.05zM23 189.13a14 14 0 0 1 1.09-8.47zm-2.44-6c-.33-2.25 1.27-5.75 2.74-6a10.93 10.93 0 0 0-2.73 5.97zM20.2 186l.8 5.17a7.59 7.59 0 0 1-.8-5.17z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20736",
    d: "M218.53 152.65l32.38 4 17.33 6.7-53.68-4.64z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2492",
    cx: 21.07,
    cy: 21.07,
    r: 21.07,
    className: "cls-16",
    transform: "translate(213.58 165.62)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2493",
    cx: 21.07,
    cy: 21.07,
    r: 21.07,
    className: "cls-16",
    transform: "translate(77.48 165.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20737",
    d: "M273.6 178.12a3.28 3.28 0 0 0-.78-1.43l-2.07-1.18.42-4.63 1.16-1.45a1.14 1.14 0 0 0 0-1.36 33.461 33.461 0 0 0-3.91-4.64l-9.07-2-8.61-3.43-7.2-.83-25.65-3-10.22-7.31a129.267 129.267 0 0 0-12.33-7.2 84.73 84.73 0 0 0-17.27-7.16c-6.63-1.78-12.7-1.75-24.85-1.69a263.649 263.649 0 0 0-33.22 2.58l-3 .42-2.68-1.31a5.68 5.68 0 0 0-2.49-.58h-.09l.42 2.52-14.6 1.56a10.381 10.381 0 0 0-2.69.66l-6.28 2.44 4.63.42-22.5 9a3.57 3.57 0 0 1-1.33.25h-3.21a.57.57 0 0 0-.45.93l.75 1 1.26 2.11-1.26.42c-1 .43-1.46 1.26-1.26 1.68s.68.47 1.26.42l-2.29 3.27a2.14 2.14 0 0 0-.23 2l.41 1v9.27l-.29.1a1.41 1.41 0 0 0-1 1.34v1.5l-.4.27a1 1 0 0 0-.29 1.44l.27.4 9.41 2.35a4.211 4.211 0 0 1 1.3.58l3.54 2.36c.6.4-4.19 4.84-3.47 4.87l5 .23a20.422 20.422 0 1 1 40.84.56v1.29l95.6 4.35a20.43 20.43 0 1 1 38.68 1.75l2.78.13a7.65 7.65 0 0 0 6.95-4.48l.71-1.78 7.79-.21 1.9-8a3.17 3.17 0 0 0-.09-1.8z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20738",
    d: "M70.9 148.76l22.32-9.68 1.27.42-19.38 8.42z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20739",
    d: "M102.5 144.11c2-1.05 11.2-5.34 14-5.83 4.3-.76 37-3.64 46.47-3.62 11.2 0 13.95.57 15.16.84 8.79 1.94 29.9 16.84 29.9 16.84-1.84 0-28.38-.58-48-1.68-22.92-1.28-22.75-1.2-29.48-1.68-9.39-.69-17.31-1.41-23.16-2a38 38 0 0 1-4.84-2 .5.5 0 0 1-.05-.87z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2494",
    cx: 17.94,
    cy: 17.94,
    r: 17.94,
    className: "cls-15",
    transform: "translate(80.77 169.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2495",
    cx: 8.44,
    cy: 8.44,
    r: 8.44,
    className: "cls-17",
    transform: "translate(90.62 178.48)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2496",
    cx: 17.94,
    cy: 17.94,
    r: 17.94,
    className: "cls-15",
    transform: "translate(216.8 169.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2497",
    cx: 8.44,
    cy: 8.44,
    r: 8.44,
    className: "cls-17",
    transform: "translate(226.66 178.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20740",
    d: "M208 152.34s-21.11-14.9-29.9-16.84c-1.21-.27-4-.82-15.16-.84-8.7 0-37.21 2.43-45 3.4v.07l-1.89.23c-3.12.75-11.65 4.74-13.59 5.75a.5.5 0 0 0 0 .89 38 38 0 0 0 4.84 2c2.8.27 6.08.58 9.76.9l3.84-5.87a4 4 0 0 1 2.94-1.8c11.36-1.22 20.93-2.21 28.56-3l1.78 13.16 5.76.32 1.34.07-4.57-14a50.74 50.74 0 0 1 11 .25 38 38 0 0 1 11.37 2.95 115.512 115.512 0 0 1 10.53 5.9l1.31.78a1.14 1.14 0 0 1 .5 1.36l-1.31 3.94c9.62.24 16.94.39 17.89.38z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20741",
    fill: "none",
    stroke: "#e8ecf0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "0.42px",
    d: "M102.5 144.11c2-1.05 11.2-5.34 14-5.83 4.3-.76 37-3.64 46.47-3.62 11.2 0 13.95.57 15.16.84 8.79 1.94 29.9 16.84 29.9 16.84-1.84 0-28.38-.58-48-1.68-22.92-1.28-22.75-1.2-29.48-1.68-9.39-.69-17.31-1.41-23.16-2a38 38 0 0 1-4.84-2 .5.5 0 0 1-.05-.87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20742",
    d: "M113.9 148.13l-6.36 5.27 3.18 16.26",
    className: "cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20743",
    d: "M157.66 151.29l1.69 7.16 1.26 9.69v11.89l.42 5.38-1.26 8.42",
    className: "cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20744",
    d: "M207.78 152.56l2.53 9.68v22.04l.42 4.92-1.26 4.63",
    className: "cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20745",
    d: "M214.13 186l-1.29-.56-66.13-5.1-21.06 1.66-1.39-3.68a18.54 18.54 0 0 0-7.44-9.1l-2.14-1.35a31.48 31.48 0 0 0-21-4.56l-.63.08a29.31 29.31 0 0 0-17 8.49l-.84.85-11.76-1.33a1.43 1.43 0 0 0-.34.92v1.5l-.4.27a1 1 0 0 0-.32 1.38l8.09 2.36.12.08 1.5.37a4.211 4.211 0 0 1 1.3.58l3.54 2.36c.14.1 0 .43-.35.87l1.12.79h1.17a20.42 20.42 0 0 1 40.31 1.56l94.91 4.72c-.04-.68-.01-2.46.03-3.16z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20746",
    d: "M78.48 186.88a20 20 0 0 1 .67-5.17c-.47-.08-6.16-3.64-6.56-3.88l-10.32-2.34a.56.56 0 0 0-.72.46l-.55 4.19a1 1 0 0 0-.44 1.28l2.11 4.52a2.59 2.59 0 0 0 1.41 1.31L79 193a3.363 3.363 0 0 0 .45.14 20.49 20.49 0 0 1-.97-6.26z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20747",
    d: "M214.25 189.3l-66.69-5.16-28.34.57a19.585 19.585 0 0 1 .12 2.17 20.4 20.4 0 0 1-1.2 6.887l46.509.693h50.91a20.26 20.26 0 0 1-1.309-5.16z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20748",
    d: "M273.7 178.48l-2.11 8.84-7.37.63s-2.19 2.1-3 2.09l-6.45-.1a20.83 20.83 0 0 1-1.23 4.54h1.44a6.109 6.109 0 0 0 1.28-.13l13.74-2.84a3.08 3.08 0 0 0 2.4-2.44l1.49-8.06a4.94 4.94 0 0 0-.19-2.53z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20749",
    d: "M264.22 171.09v.14a105.61 105.61 0 0 0-40-10.25l-4.63 3.37q-6.66-1.12-13.48-2.11a624.445 624.445 0 0 0-77.11-6.32h-7.58a86.36 86.36 0 0 1 26.12 23.17l8.84.84 56 4.21 1.84.25a20.42 20.42 0 1 1 40.78 2.23l1.69.07h11.81l2.95-10.53.13-5z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20750",
    d: "M251.59 162.24l4.21-1.68h1.87a21.92 21.92 0 0 1 9 2.47 2.46 2.46 0 0 1 1.19 1.4l.74 2.23h-5.47a3.45 3.45 0 0 1-1.3-.25z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20751",
    d: "M65.51 149.68l.75 1 1.26 2.11-1.26.42c-1 .43-1.46 1.26-1.26 1.68s.68.47 1.26.42L64 158.56a2.14 2.14 0 0 0-.23 2l.41 1v9.27l-.29.1a1.26 1.26 0 0 0-.33.16l11.36 1.21c.4-.56.4-.28.85-.84A39.37 39.37 0 0 1 90.3 160.3z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20752",
    d: "M207.15 148.13c1.14.87 2.76 2.15 4.63 3.79h2.31a.47.47 0 0 0 .17-.9l-1-.37h-.25a128.528 128.528 0 0 0-17.69-10.95 104.7 104.7 0 0 0-11.86-5.43l-1 .59c.76.26 1.94.69 3.37 1.26a90.33 90.33 0 0 1 21.32 12.01z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20753",
    d: "M65.17 153.75l1.94-1.62 6 1.13a5.94 5.94 0 0 1 1.41.45l4 1.79-4.14 2.43a3.44 3.44 0 0 1-3.79-.2L68 155.84a4.141 4.141 0 0 0-.68-.39l-2-.9a.48.48 0 0 1-.15-.8z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20754",
    d: "M113.86 157.19h6.74a2.53 2.53 0 0 1 2.53 2.53h-11.8a2.53 2.53 0 0 1 2.53-2.53z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20755",
    d: "M164.4 159.72h6.74a2.53 2.53 0 0 1 2.53 2.53h-11.79a2.53 2.53 0 0 1 2.52-2.53z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20756",
    d: "M193.27 145h1a7.58 7.58 0 0 1 7.58 7.58H194a3.9 3.9 0 0 1-3.9-3.9v-.5a3.18 3.18 0 0 1 3.17-3.18z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20757",
    d: "M214.1 151.71l3.79 2.53 32.85 3.79 5.9 2.53-9.69 4.21-2.95 2.11",
    className: "cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20758",
    d: "M220.25 154.51l35.47-32.41-3.54-1.44-37.62 33.85z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20759",
    d: "M215.71 156.87l37-34.59 1.58.66a3.59 3.59 0 0 1 2 2.2l.53 1.62 4.07-.63-1.42-3.49a4.9 4.9 0 0 0-2.76-2.73l-3.54-1.38a2.27 2.27 0 0 0-2.29.39l-41.59 36z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_58",
    fill: "none",
    stroke: "#474e5e",
    strokeMiterlimit: 10,
    strokeWidth: "1.09px",
    d: "M0 0L10.21 33.94",
    transform: "translate(248.17 127.95)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarCrash);
export default __webpack_public_path__ + "static/media/car-crash.062e3d0a78dfe28e926f51c28dcc888b.svg";
export { ForwardRef as ReactComponent };